import styled from 'styled-components/macro';
import { TeaserCard } from '@yme/molecules/cards/teaser-card';
export const TeaserCardStyled = styled(TeaserCard) `
  display: flex;
  align-items: end;

  > div {
    width: 100%;
  }
`;
